import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context) || {}
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($page: Int, $filter: ServiceOrderFilter) {
    serviceOrders(page: $page, filter: $filter, recursive: true, limit: 50, sort: { field: ID, type: ASC }) {
      id
      yearlyId
      priority {
        id
        name
      }
      status {
        id
        name
      }
      checklist {
        id
        name
      }
      place {
        id
        name
        resume
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, filter, noPagination }) => {
  const { ids } = useModalData()

  const { data, fetchMore, variables, ...state } = useQuery(QUERY, {
    variables: {
      filter: { ids }
    },
    skip: !ids,
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default ServiceOrdersLoader
